import { FileText, Shield, Download, Eye } from 'lucide-react';

const Legal = () => {
    const openPan = () => {
        window.open("/Sagwara_PAN.pdf", "_blank");
    };
    const openCertificate = () => {
        window.open("/Sagwara_Certi.pdf", "_blank");
    };
    return (
        <section id="legal" className="py-16 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="text-center mb-12">
                    <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Legal Documentation</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Official documents and registration certificates
                    </p>
                </div>

                <div className="max-w-4xl mx-auto">
                    <div className="bg-amber-50 rounded-xl p-6 mb-6 border border-amber-200">
                        <div className="flex items-center mb-4">
                            <Shield className="w-8 h-8 text-amber-900 mr-3" />
                            <h3 className="text-xl font-bold text-gray-900">Rajasthan-State Co-operative Registration</h3>
                        </div>
                        <p className="text-sm text-gray-700 mb-4">
                            Sagwara Apni Bachat Ghar Mahila Sahakari Samiti Limited. is a duly registered Rajasthan-state credit co-operative society operating under the Rajasthan-State Co-operative Societies Act, 2002.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6">
                        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                            <div className="flex items-center mb-4">
                                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 mr-4">
                                    <FileText className="w-6 h-6" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900">Registration Certificate</h3>
                            </div>
                            <p className="text-sm text-gray-700 mb-4">
                                Official registration certificate confirming our status as a Rajasthan-state credit co-operative society.
                            </p>
                            <div className="bg-gray-50 p-3 rounded-lg mb-4 h-[120px]">
                                <p className="text-xs text-gray-600 mb-1">Document Type:</p>
                                <p className="text-sm font-semibold text-gray-900">Rajasthan-State Co-operative Registration</p>
                            </div>
                            <button
                                onClick={openCertificate}
                                className="w-full px-4 py-2 bg-amber-900 text-white rounded-lg font-semibold hover:bg-amber-800 transition-colors flex items-center justify-center">
                                <Eye className="w-4 h-4 mr-2" />
                                Certificate
                            </button>

                        </div>

                        <div className="bg-white rounded-xl p-6 shadow-lg border border-gray-200 hover:shadow-xl transition-shadow">
                            <div className="flex items-center mb-4">
                                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center text-amber-900 mr-4">
                                    <FileText className="w-6 h-6" />
                                </div>
                                <h3 className="text-lg font-bold text-gray-900">PAN Card</h3>
                            </div>
                            <p className="text-sm text-gray-700 mb-4">
                                Permanent Account Number (PAN) card issued by the Income Tax Department of India.
                            </p>
                            <div className="bg-gray-50 p-3 rounded-lg mb-4 h-[120px]">
                                <p className="text-xs text-gray-600 mb-1">PAN Number:</p>
                                <p className="text-sm font-semibold text-gray-900">ACRAS7352K</p>
                                <p className="text-xs text-gray-600 mt-2 mb-1">Issue Date:</p>
                                <p className="text-sm font-semibold text-gray-900">07/08/2025</p>
                            </div>
                            <button
                                onClick={openPan}
                                className="w-full px-4 py-2 bg-amber-900 text-white rounded-lg font-semibold hover:bg-amber-800 transition-colors flex items-center justify-center">
                                <Eye className="w-4 h-4 mr-2" />
                                PAN Card
                            </button>

                        </div>
                    </div>

                    <div className="mt-8 bg-amber-50 rounded-xl p-6 border border-amber-200">
                        <h3 className="text-lg font-bold text-gray-900 mb-3">Important Notice</h3>
                        <p className="text-sm text-gray-700 leading-relaxed">
                            All legal documents displayed on this website are for informational purposes. For official verification or to obtain certified copies, please contact our head office or visit us in person. We maintain complete transparency and are committed to regulatory compliance at all times.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Legal;
